import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import * as thunks from "./thunks";
import dayjs from "dayjs";
import { GetUserRMAPayload, UserRmaState } from "./types";

const initialState: UserRmaState = {
  userRma: [],
  isUserRmasLoading: false,
  isUserRmaDetailsLoading: false,
  getUserRmaPayload: {
    serial_no: "",
    ecomm_order_no: "",
  },
  getUserRmaResponse: {},
};

const slice = createSlice({
  name: "UserRma",
  initialState,
  reducers: {
    updateGetDetailsPayload: (
      state,
      { payload }: PayloadAction<GetUserRMAPayload>
    ) => {
      state.getUserRmaPayload = {
        ...state.getUserRmaPayload,
        ...payload,
      };
    },
  },
  extraReducers(builder) {
    // Details
    builder.addCase(
      thunks.getUserRmaDetailsThunk.pending,
      (state, { payload }) => {
        state.isUserRmaDetailsLoading = true;
      }
    );
    builder.addCase(
      thunks.getUserRmaDetailsThunk.rejected,
      (state, { payload }) => {
        state.isUserRmaDetailsLoading = false;
      }
    );
    builder.addCase(
      thunks.getUserRmaDetailsThunk.fulfilled,
      (state, { payload }) => {
        state.isUserRmaDetailsLoading = false;
        state.userRma = payload?.originalData?.data || [];
        state.getUserRmaResponse = payload?.originalData || {};
      }
    );
  },
});

export const reducer = slice.reducer;
export const actions = { ...slice.actions, ...thunks };
